import {injectable} from "inversify";

@injectable()
export class PubSub {
    private eventSubscribers = new Map<string, EventSubscriber[]>();
    private eventIdToEventMap = new Map<number, string>();
    private eventIdSeq = 0;

    publishEvent(eventName: string, data: any): Promise<any> {
        let subscribers = this.eventSubscribers.get(eventName);
        if (subscribers == null || subscribers.length === 0)
            return Promise.resolve();

        let promises: Promise<any>[] = [];
        subscribers.forEach(s =>  {
            if (s != null) {
                let result = s.eventHandler(data);
                if (result && result['then']) {
                    promises.push(result);
                }
            }
        });

        return Promise.all(promises);
    }

    subscribeToEvent(eventName: string, callback: (data: any) => any): number {
        let subscribers = this.eventSubscribers.get(eventName);
        let sub: EventSubscriber = {
            subscriberId: this.eventIdSeq,
            eventHandler: callback
        };
        this.eventIdToEventMap.set(this.eventIdSeq, eventName);
        this.eventIdSeq += 1;

        if (subscribers == null) {
            this.eventSubscribers.set(eventName, [sub]);
            return sub.subscriberId;
        }
        else {
            subscribers.push(sub);
            return sub.subscriberId;
        }
    }

    unsubscribeToEvent(id: number): void {
        let event = this.eventIdToEventMap.get(id);
        if (event == null)
            return;

        let subscribers = this.eventSubscribers.get(event);
        if (subscribers == null)
            return;

        let index = subscribers.findIndex(s => s.subscriberId === id);
        if (index > -1)
            subscribers.splice(index, 1);
    }
}

interface EventSubscriber {
    subscriberId: number;
    eventHandler: (data: any) => void|Promise<any>;
}